/**
 * Mede a largura do espaço onde o gráfico vai ficar, e mede de novo quando a
 * janela muda. Os gráficos são desenhados na largura real (em pixels), então
 * o texto fica sempre do tamanho certo, no computador e no celular.
 *
 * Lê: o tamanho do elemento na tela.
 * Usado por: componentes/CartaoGrafico.tsx.
 */
import { useLayoutEffect, useRef, useState, type RefObject } from 'react';

export function usarLargura<T extends HTMLElement>(): [RefObject<T | null>, number] {
  const referencia = useRef<T>(null);
  const [largura, setLargura] = useState(0);
  useLayoutEffect(() => {
    const elemento = referencia.current;
    if (!elemento) return;
    setLargura(Math.round(elemento.getBoundingClientRect().width));
    const observador = new ResizeObserver((entradas) => {
      const entrada = entradas[0];
      if (entrada) setLargura(Math.round(entrada.contentRect.width));
    });
    observador.observe(elemento);
    return () => observador.disconnect();
  }, []);
  return [referencia, largura];
}
